(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 0;
      this.messageEl = this.querySelector('[data-fsb-message]');
      this.fillEl = this.querySelector('[data-fsb-fill]');
      this.trackEl = this.querySelector('[role="progressbar"]');
      this.boundUpdate = this.onCartUpdate.bind(this);
      document.addEventListener('cart:update', this.boundUpdate);
      document.addEventListener('cart:refresh', this.boundUpdate);
      document.addEventListener('cart:updated', this.boundUpdate);
      document.addEventListener('cart:lines-update', this.boundUpdate);
      this.render(parseInt(this.dataset.total, 10) || 0);

      // Fallback poll: cart-drawer/cart-page instances already refresh via this theme's
      // own Section Rendering API re-render. This poll exists for standalone instances
      // (e.g. the site-wide bar above the header) that sit outside that reactive markup
      // and would otherwise go stale until the next full page load.
      this._pollId = window.setInterval(() => {
        if (document.hidden) return;
        this.onCartUpdate();
      }, 5000);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:update', this.boundUpdate);
      document.removeEventListener('cart:refresh', this.boundUpdate);
      document.removeEventListener('cart:updated', this.boundUpdate);
      document.removeEventListener('cart:lines-update', this.boundUpdate);
      if (this._pollId) window.clearInterval(this._pollId);
    }
    onCartUpdate(event) {
      const detailTotal = event && event.detail && (event.detail.cart ? event.detail.cart.total_price : event.detail.total_price);
      if (typeof detailTotal === 'number') {
        this.render(detailTotal);
      } else {
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then((cart) => this.render(cart.total_price))
          .catch(function () {});
      }
    }
    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return '$' + amount;
    }
    render(total) {
      const threshold = this.threshold;
      const remaining = Math.max(threshold - total, 0);
      let pct = threshold > 0 ? Math.round((total / threshold) * 100) : 100;
      if (pct > 100) pct = 100;
      if (this.fillEl) this.fillEl.style.width = pct + '%';
      if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', String(pct));
      if (remaining <= 0) {
        this.classList.add('is-unlocked');
        if (this.messageEl) this.messageEl.innerHTML = "🎉 You've unlocked <strong>FREE shipping!</strong>";
      } else {
        this.classList.remove('is-unlocked');
        if (this.messageEl) this.messageEl.innerHTML = "You're <span data-fsb-remaining>" + this.formatMoney(remaining) + '</span> away from <strong>FREE shipping!</strong> 🚚';
      }
    }
  }
  if (!customElements.get('free-shipping-bar')) {
    customElements.define('free-shipping-bar', FreeShippingBar);
  }
  } catch(e) { console.error(e); }
})();

})();
